module.exports = __webpack_public_path__ + "static/abouttop_sustainability-1079d2d5ab5ff3f629e8dfdd8e561cd9.mp4";